import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AdminLayout from "../layout/admin-layout.vue";
import AppLayout from "../layout/app-layout.vue";
import ClubLayout from "../layout/club-layout.vue";
import AuthLayout from "../layout/auth-layout.vue";
import store from "@/store";
import {
  clubUUID,
  currentClub,
  userUUID,
  loggedIn,
  closeSidebar,
} from "@/shared/state";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:catchAll(.*)",
    redirect: { name: "login" },
  },
  {
    name: "user",
    path: "/user",
    component: ClubLayout,
    children: [
      {
        name: "list-clubs",
        path: "list-clubs/:userUUID",
        component: () => import("../pages/clients/club/index.vue"),
      },
      {
        name: "inactive-subscription",
        path: "inactive-subscription/:userUUID",
        component: () => import("../pages/clients/club/inactive.vue"),
      },
      {
        name: "create-club",
        path: "create-club/:userUUID",
        component: () => import("../pages/clients/club/add.vue"),
      },

      {
        name: "renew-subscription-club",
        path: "renew-subscription-club/:userUUID/:clubUUID",
        component: () => import("../pages/clients/club/renew.vue"),
      },

      {
        name: "payment-success",
        path: "payment-success/:userUUID/:clubUUID/:subscriptionClubID",
        component: () => import("../pages/clients/club/paymentSuccess.vue"),
      },
      {
        name: "payment-cancel",
        path: "payment-cancel/:userUUID/:clubUUID/:subscriptionClubID",
        component: () => import("../pages/clients/club/paymentCancel.vue"),
      },
      {
        name: "club-created-success",
        path: "club-created-success/:userUUID",
        component: () => import("../pages/clients/club/clubCreated.vue"),
      },
      {
        name: "profile",
        path: "profile/:userUUID",
        component: () => import("../pages/clients/user/profile.vue"),
      },
      {
        name: "support",
        path: "support/:userUUID",
        component: () => import("../pages/clients/support/index.vue"),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!loggedIn.value) {
        return next({ name: "login" });
      }
      next();
    },
  },
  {
    name: "gymya",
    path: "/",
    component: AppLayout,
    children: [
      {
        name: "whatsapp-connect",
        path: "whatsapp/connect/:clubUUID",
        component: () => import("../pages/clients/whatsapp/index.vue"),
      },
      {
        name: "accesRapideFirst",
        path: "/",
        component: () => import("../pages/clients/dashboard/accesRapide.vue"),
      },
      {
        name: "dashboard",
        path: "dashboard/:clubUUID",
        component: () => import("../pages/clients/dashboard/index.vue"),
      },
      {
        name: "access-rapide",
        path: "access-rapide/:clubUUID",
        component: () => import("../pages/clients/dashboard/accesRapide.vue"),
      },
      {
        name: "packs",
        path: "packs/:clubUUID",
        component: () => import("../pages/clients/pack/index.vue"),
      },
      {
        name: "subscriptions",
        path: "subscriptions/:clubUUID",
        component: () => import("../pages/clients/subscriptions/index.vue"),
      },
      {
        name: "fees",
        path: "fees/:clubUUID",
        component: () => import("../pages/clients/fees/index.vue"),
      },
      {
        name: "cash-journals",
        path: "cash-journals/:clubUUID",
        component: () => import("../pages/clients/cashJournal/index.vue"),
      },
      {
        name: "assurances",
        path: "assurances/:clubUUID",
        component: () => import("../pages/clients/assurances/index.vue"),
      },
      {
        name: "promotions",
        path: "promotions/:clubUUID",
        component: () => import("../pages/clients/promoPack/promoPack.vue"),
      },
      {
        name: "pointeuses",
        path: "pointeuses/:clubUUID",
        component: () => import("../pages/clients/pointeuse/index.vue"),
      },
      {
        name: "schedules-templates",
        path: "schedules-templates/:clubUUID",
        component: () =>
          import("../pages/clients/pointeuseISAPI/schedulesTemplates.vue"),
      },
      {
        name: "add-schedules-templates",
        path: "add-schedules-templates/:clubUUID",
        component: () =>
          import("../pages/clients/pointeuseISAPI/addSchedulesTemplates.vue"),
      },
      {
        name: "edit-schedules-templates",
        path: "edit-schedules-templates/:clubUUID/:id",
        component: () =>
          import("../pages/clients/pointeuseISAPI/editSchedulesTemplates.vue"),
      },
      {
        name: "attendances-hikvision",
        path: "attendances-hikvision/:clubUUID",
        component: () =>
          import("../pages/clients/pointeuseISAPI/hikvisionAttendance.vue"),
      },
      {
        name: "delete-person-from-pointeuses",
        path: "pointeuses/person/delete/:clubUUID",
        component: () =>
          import("../pages/clients/pointeuseISAPI/Member/Delete/index.vue"),
      },
      {
        name: "add-person-to-pointeuses",
        path: "pointeuses/person/create/:clubUUID",
        component: () =>
          import("../pages/clients/pointeuseISAPI/Member/Add/index.vue"),
      },
      {
        name: "test-connection",
        path: "raspberry/connection/:clubUUID",
        component: () =>
          import("../pages/clients/pointeuseISAPI/TestConnection.vue"),
      },

      {
        name: "incomes",
        path: "incomes/:clubUUID",
        component: () => import("../pages/clients/income/index.vue"),
      },

      {
        name: "incomes-categories-services",
        path: "incomes-categories-services/:clubUUID",
        component: () =>
          import("../pages/clients/income/categories_services.vue"),
      },
      {
        name: "incomes-regulations-stats",
        path: "incomes-regulations-stats/:clubUUID",
        component: () =>
          import("../pages/clients/income/incomes_regulations_stats.vue"),
      },
      {
        name: "expenses",
        path: "expenses/:clubUUID",
        component: () => import("../pages/clients/expense/index.vue"),
      },
      {
        name: "expenses-regulations-stats",
        path: "expenses-regulations-stats/:clubUUID",
        component: () =>
          import("../pages/clients/expense/expenses_regulations_stats.vue"),
      },
      {
        name: "expenses-categories-services",
        path: "expenses-categories-services/:clubUUID",
        component: () =>
          import("../pages/clients/expense/categories_services.vue"),
      },

      {
        name: "clubs",
        path: "clubs/:userUUID",
        component: () => import("../pages/clients/club/index.vue"),
      },
      {
        name: "trainers",
        path: "employees/:clubUUID",
        component: () => import("../pages/clients/trainers/index.vue"),
      },

      {
        name: "fiche-trainer",
        path: "employee/fiche/:trainerID/:clubUUID",
        component: () => import("../pages/clients/trainers/detailsTrainer.vue"),
      },

      {
        name: "members",
        path: "members/:clubUUID",
        component: () => import("../pages/clients/member/index.vue"),
      },
      {
        name: "members-renewed-status",
        path: "members/renewal/:clubUUID",
        component: () => import("../pages/clients/member/renewalStatus.vue"),
      },

      {
        name: "assurances-members",
        path: "members/assurances/:clubUUID",
        component: () =>
          import("../pages/clients/member/assurances_members.vue"),
      },
      {
        name: "members-with-pointeuses-errors",
        path: "members/pointeuse-errors/:clubUUID",
        component: () =>
          import("../pages/clients/member/members_with_pointeuses_errors.vue"),
      },

      {
        name: "fiche",
        path: "fiche/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/member/fiches.vue"),
      },

      {
        name: "inscription",
        path: "inscription/:clubUUID",
        component: () => import("../pages/clients/member/inscription.vue"),
      },

      {
        name: "prospection",
        path: "prospection/:clubUUID",
        component: () => import("../pages/clients/member/prospection.vue"),
      },
      {
        name: "create-prospection",
        path: "prospection/create/:clubUUID",
        component: () =>
          import("../pages/clients/member/inscription_prospect.vue"),
      },
      {
        name: "renew-member-subscription",
        path: "member/renew/subscription/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/member/renewal.vue"),
      },
      {
        name: "cancel-member-subscription",
        path: "member/cancel/subscription/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/member/canceled.vue"),
      },
      {
        name: "pause-member-subscription",
        path: "member/pause/subscription/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/member/pause.vue"),
      },
      {
        name: "update-datefin",
        path: "subscription/update/datefin/:clubUUID/:memberUUID/:subscriptionID",
        component: () => import("../pages/clients/member/updateDateFin.vue"),
      },
      {
        name: "resume-member-subscription",
        path: "member/resume/subscription/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/member/resume.vue"),
      },
      {
        name: "active-subscriptions",
        path: "active-subscriptions/:clubUUID",
        component: () =>
          import("../pages/clients/member/activeSubscriptions.vue"),
      },
      {
        name: "expired-subscriptions",
        path: "expired-subscriptions/:clubUUID",
        component: () =>
          import("../pages/clients/member/expiredSubscriptions.vue"),
      },
      {
        name: "subscriptions-expiring",
        path: "subscriptions-expiring/:clubUUID",
        component: () =>
          import("../pages/clients/member/subscriptionsExpiring.vue"),
      },
      {
        name: "historiques-subscriptions",
        path: "historiques-subscriptions/:clubUUID",
        component: () =>
          import("../pages/clients/member/historiques_subscriptions.vue"),
      },
      {
        name: "historiques-subscriptions-member",
        path: "historiques-subscriptions-member/:clubUUID/:memberUUID",
        component: () =>
          import("../pages/clients/member/historiquesSubscriptionsMember.vue"),
      },
      {
        name: "subscription-participations",
        path: "subscription-participations/:clubUUID/:memberSubscriptionId",
        component: () =>
          import("../pages/clients/member/subscriptionParticipations.vue"),
      },
      {
        name: "logs-sync-members",
        path: "logs-sync-members/:clubUUID",
        component: () => import("../pages/clients/logs/logsSyncMembers.vue"),
      },
      {
        name: "global-revenu",
        path: "global-revenu/:clubUUID",
        component: () => import("../pages/clients/reporting/global_revenu.vue"),
      },
      {
        name: "member/global-revenu",
        path: "member-global-revenu/:clubUUID/:memberUUID",
        component: () =>
          import("../pages/clients/reporting/member_global_revenu.vue"),
      },
      {
        name: "packs-sales",
        path: "/subscriptions/packs/sold/:clubUUID",
        component: () => import("../pages/clients/member/packsSalesStats.vue"),
      },
      {
        name: "send-mail",
        path: "send-mail/:clubUUID",
        component: () => import("../pages/clients/member/sendMail.vue"),
      },
      {
        name: "send-whatsapp",
        path: "whatsapp/message/:clubUUID",
        component: () =>
          import("../pages/clients/whatsapp/CustomWhatsAppMessage.vue"),
      },
      {
        name: "credits",
        path: "credits/:clubUUID",
        component: () => import("../pages/clients/payment/credits.vue"),
      },
      {
        name: "credits-member",
        path: "credits-member/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/payment/credits_member.vue"),
      },
      {
        name: "impayes",
        path: "impayes/:subscriptionID/:clubUUID/:memberUUID",
        component: () => import("../pages/clients/payment/impayes.vue"),
      },
      {
        name: "historiques-reglements",
        path: "historiques-reglements/:clubUUID",
        component: () =>
          import("../pages/clients/payment/historiquesReglements.vue"),
      },
      {
        name: "encaissements",
        path: "encaissements/:clubUUID",
        component: () => import("../pages/clients/payment/encaissements.vue"),
      },
      {
        name: "encaissements-member",
        path: "encaissements-member/:clubUUID/:memberUUID",
        component: () =>
          import("../pages/clients/payment/encaissements_member.vue"),
      },
      {
        name: "decaissements",
        path: "decaissements/:clubUUID",
        component: () => import("../pages/clients/payment/decaissements.vue"),
      },
      {
        name: "reporting-cashflow-expenses",
        path: "reporting/cashflow/expenses/:clubUUID",
        component: () =>
          import("../pages/clients/payment/reportingCashFlowExpenses.vue"),
      },
      {
        name: "reporting-cashflow-incomes",
        path: "reporting/cashflow/incomes/:clubUUID",
        component: () =>
          import("../pages/clients/payment/reportingCashFlowIncomes.vue"),
      },
      {
        name: "member-reporting-cashflow-incomes",
        path: "reporting/cashflow/incomes/:clubUUID/:memberUUID",
        component: () =>
          import("../pages/clients/payment/reportingCashFlowIncomesMember.vue"),
      },

      {
        name: "reporting",
        path: "reporting/:clubUUID",
        component: () => import("../pages/clients/reporting/index.vue"),
      },
      {
        name: "announcements",
        path: "announcements/:clubUUID",
        component: () => import("../pages/clients/announcements/index.vue"),
      },
      {
        name: "announcements-display",
        path: "announcements-display/:clubUUID",
        component: () =>
          import("../pages/clients/announcements/announcementDisplay.vue"),
      },
      {
        name: "presences",
        path: "presences/:clubUUID",
        component: () => import("../pages/clients/presence/index.vue"),
      },
      {
        name: "hitoriques-presences",
        path: "hitoriques-presences/:clubUUID",
        component: () =>
          import("../pages/clients/presence/history_presences.vue"),
      },
      {
        name: "members-checkins",
        path: "members/checkins/:clubUUID",
        component: () =>
          import("../pages/clients/presence/membersCheckins.vue"),
      },
      {
        name: "daily-member-activity",
        path: "daily-member-activity/:clubUUID",
        component: () =>
          import("../pages/clients/presence/dailyMemberActivity.vue"),
      },
      {
        name: "public-sessions",
        path: "public-sessions/:clubUUID",
        component: () => import("../pages/clients/publicSession/index.vue"),
      },
      {
        name: "add-public-sessions",
        path: "add-public-sessions/:clubUUID",
        component: () => import("../pages/clients/publicSession/add.vue"),
      },
      {
        name: "edit-public-sessions",
        path: "session/public/edit/:sessionID/:clubUUID",
        component: () => import("../pages/clients/publicSession/add.vue"),
      },
      {
        name: "schedules",
        path: "schedules/:clubUUID",
        component: () => import("../pages/clients/publicSession/schedule.vue"),
      },
      {
        name: "session-booked",
        path: "session/booked/:clubUUID/:id",
        component: () =>
          import("../pages/clients/publicSession/bookedSession.vue"),
      },
      {
        name: "settings-club",
        path: "settings-club/:clubUUID",
        component: () => import("../pages/clients/settings/index.vue"),
      },

      {
        name: "business-insights",
        path: "business-insights/:clubUUID",
        component: () => import("../pages/clients/reporting/insights.vue"),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!loggedIn.value) {
        return next({ name: "login" });
      } else {
        if (!clubUUID.value) {
          return next({ name: "clubs", params: { userUUID: userUUID.value } });
        } else {
          if (!currentClub.value?.active_subscription) {
            return next({
              name: "inactive-subscription",
              params: { userUUID: userUUID.value },
            });
          }
        }
      }
      next();
    },
  },

  {
    name: "admin",
    path: "/admin",
    component: AdminLayout,
    children: [
      {
        name: "clubs",
        path: "clubs/:userUUID",
        component: () => import("../pages/clients/club/indexs.vue"),
      },
      {
        name: "details-club",
        path: "details-club/:userUUID/:clubUUID",
        component: () => import("../pages/clients/club/detailsClub.vue"),
      },
      {
        name: "users",
        path: "users/:userUUID",
        component: () => import("../pages/clients/user/assistances.vue"),
      },
      {
        name: "assign-user",
        path: "/clubs/assign-user",
        component: () => import("../pages/clients/user/affected_user.vue"),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!loggedIn.value) {
        return next({ name: "login" });
      }
      next();
      ///  return next({ name: 'user-permissions', params: { userUUID: userUUID.value } })
    },
  },
  {
    name: "super-admin",
    path: "/super-admin",
    component: AdminLayout,
    children: [
      {
        name: "gymya-clubs",
        path: "clubs",
        component: () => import("../pages/super-admin/club/index.vue"),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!loggedIn.value) {
        return next({ name: "login" });
      }
      next();
      ///  return next({ name: 'user-permissions', params: { userUUID: userUUID.value } })
    },
  },
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        name: "signup",
        path: "signup",
        component: () => import("../pages/auth/signup/signup.vue"),
      },
      {
        name: "login",
        path: "login",
        component: () => import("../pages/auth/login/Login.vue"),
        beforeEnter: (to, from, next) => {
          if (loggedIn.value) {
            return next({
              name: "list-clubs",
              params: { userUUID: userUUID.value },
            });
          } else {
            next();
          }
        },
      },
      {
        name: "auth-recover-password",
        path: "auth-recover-password",
        component: () => import("../pages/auth/password/RecoverPassword.vue"),
        beforeEnter: (to, from, next) => {
          if (loggedIn.value) {
            return next({
              name: "list-clubs",
              params: { userUUID: userUUID.value },
            });
          } else {
            next();
          }
        },
      },
      {
        name: "reset-password",
        path: "reset-password/:token",
        component: () => import("../pages/auth/password/ResetPassword.vue"),
        beforeEnter: (to, from, next) => {
          if (loggedIn.value) {
            return next({
              name: "list-clubs",
              params: { userUUID: userUUID.value },
            });
          } else {
            next();
          }
        },
      },
      {
        path: "",
        redirect: { name: "login" },
      },
    ],
  },
  {
    name: "stock",
    path: "/stock",
    component: AppLayout,
    children: [
      {
        name: "list-products",
        path: "list-products/:clubUUID",
        component: () => import("../pages/clients/stock/product/index.vue"),
      },
      {
        name: "list-categories",
        path: "list-categories/:clubUUID",
        component: () => import("../pages/clients/stock/category/index.vue"),
      },

      {
        name: "orders",
        path: "orders/:clubUUID",
        component: () => import("../pages/clients/stock/sale/index.vue"),
      },
      {
        name: "stock-add-order",
        path: "stock-add-order/:clubUUID",
        component: () =>
          import("../pages/clients/stock/createOrderProduct.vue"),
      },
      {
        name: "stock-add-order-spa",
        path: "stock-add-order-spa/:clubUUID",
        component: () => import("../pages/clients/stock/createOrderSpa.vue"),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!loggedIn.value) {
        return next({ name: "login" });
      }
      next();
    },
  },
  {
    path: "/error",
    component: AuthLayout,
    children: [
      {
        name: "404",
        path: "404",
        component: () => import("../pages/error/404.vue"),
      },
      {
        path: "",
        redirect: { name: "404" },
      },
    ],
  },
  {
    path: "/display",
    //component: AuthLayout,
    children: [
      {
        name: "announcements-display",
        path: "announcements-display/:clubUUID/:announcementsIDs",
        component: () =>
          import("../pages/clients/announcements/announcementDisplay.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach(() => {
  if (window.innerWidth < 992) {
    closeSidebar();
  }
});

export default router;
